// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-ele-form-data-editor.is-error .el-textarea__inner{border-color:#f56c6c}.vue-ele-form-data-editor.is-error .err-msg{color:#f56c6c}.vue-ele-form-data-editor.is-success .el-textarea__inner{border-color:#67c23a;border-style:dashed}", ""]);
// Exports
module.exports = exports;
